
                import { Component } from "/app/packages/sintra/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/sintra/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/sintra/lib/views/shared/_sintra/_table.js";
                const hash = "0JfjgU2S74";
                Component.include(createDecoratorsInclude(hash, decorators));
            